<template>
  <div class="app-header">
    <div class="app-row">
      <img class="app-header-logo" src="@/assets/logo.svg" />
      <button class="app-close" v-on:click="closeApp()">x sluiten</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AppHeader',
    methods: {
      closeApp : function() {
        let d = document.getElementById('app').classList.remove('open')
      }
    },
  }
</script>

<style scoped lang="scss">
  .app-header {
    height: 175px;
    max-height: 175px;
    width: 100%;
    background-color: #fff;

    .app-row {
      padding-top: 60px;
      padding-bottom: 60px;
    }

    .app-header-logo {
      float: left;
      width: 100%;
      max-width: 240px;
      height: auto;
    }

    .app-close {
      float: right;
      border: 0;
      padding: 40px 0 40px 40px;
      color: $color-primary;
      cursor: pointer;
    }
  }
</style>
